export default __webpack_public_path__ + "static/media/miguel-lopes-34.9ce48d82.jpg";